<app-content-loader [contentTemplate]="contentTemplate">
  <ng-template #contentTemplate>
    <div [style]="'width:' + size + 'px;'" class="text"></div>
  </ng-template>
</app-content-loader>
